import FBtnMDP, { BtnType } from "@/components/FBtnMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";
import MDP from "@/components/MDP";

import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";

import * as Snackbar from "node-snackbar";
import FRemoteAutoCompleteFieldMDP from "@/components/form/field/FRemoteAutoCompleteFieldMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FCreditCardFieldMDP from "@/components/form/field/FCreditCardFieldMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import FFormSubmitBtnMDP from "@/components/FFormSubmitBtnMDP";


export default class FUpdateClientCreditorFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  constructor({ taskRoot, parent }: { taskRoot: any; parent: any }) {
    super({
      myRefName: "editCreditorFormRef",
      disabled: taskRoot.taskDisabled,
    });
    this.taskRoot = taskRoot;
    this.parent = parent;

    this.addField(
      new FRemoteAutoCompleteFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "creditorName",
        label: "Creditor",
        mandatory: true,
        boundaryClass: "col-4",
        queryUrl: "/spineapi/master/search-creditor?creditorName=",
        disabled: true
      })
    )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "creditorBalance",
          label: "Creditor Balance",
          mandatory: true,
          boundaryClass: "col-4",
        })
      )

      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "emiAmount",
          label: "EMI Amount",
          mandatory: true,
          boundaryClass: "col-4",
        })
      )
      .addField(
        new FSelectDateFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "lastDateOfPayment",
          label: "Last Date of Payment",
          mandatory: true,
          boundaryClass: "col-4",
          futureDaysDisabled: true,
        })
      )

      .addField(
        new FSelectFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "debtType",
          label: "Type of Debt",
          mandatory: true,
          boundaryClass: "col-4",
          options: [
            "Credit Card",
            "Personal Loans",
            "Secured",
            "Others (Unsecured)",
          ],
        })
      )

      .addField(
        new FCreditCardFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "accountNumber",
          label: "Credit Card Number",
          mandatory: true,
          boundaryClass: "col-4",
          condition: this.parent.isCreditCard(),
          rules: "min:4|max:20",
        })
      )

      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "accountNumber",
          label: "Account Number",
          mandatory: true,
          boundaryClass: "col-4",
          condition: !this.parent.isCreditCard(),
          // rules: "min:9|max:20",
          rules: "min:4|max:20",
        })
      ).addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "details",
          label: "Details",
        })
      )
      .addAction(
        new FBtnMDP({
          label: "Cancel",
          btnType: BtnType.TEXT,
          onClick: () => {
            this.parent.closeAndClearAllForms()
          },
        })
      )
      .addAction(
        new FFormSubmitBtnMDP({
          label: "Update Creditor",
          onClick: () => this.updateCreditor(),
        })
      );
  }

  getMyRef(): any {
    return this.parent.$refs[this.myRefName];
  }



  updateCreditor() {
    Action.ClientFile.UpdateClCreditor.execute(this.parent.updateClCreditorInput, (output) => {
      this.parent.closeAndClearAllForms();
      Snackbar.show({
        text: "Succesfully Updated",
        pos: "bottom-center",
      });
    });
  }
}
